<template>
  <div :class="['ipub-editor', isFocus?'ipub-editor--active':'']">
    <textarea :value='value' :id='tinymceId'>
    </textarea>
  </div>
</template>

<script>
const tinymceScript = 'https://cdnjs.cloudflare.com/ajax/libs/tinymce/5.10.9/tinymce.min.js'
export default {
  name: 'IpubEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      tinymceId: 'tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + ''),
      isFocus: false,
      hasInit: false
    }
  },
  mounted() {
    try {
      if (this.getTinymce()) {
        this.initTinymce()
      } else {
        this.loadTinymceScript()
      }
    }catch (error){
      console.log('tinymce init error',error)
    }
  },
  watch: {
    value(val) {
      if (this.getTinymce() && this.hasInit && val !== this.getContent()) {
        this.setContent(val)
        this.getTinymce().get(this.tinymceId).selection.select(this.getTinymce().get(this.tinymceId).getBody(), true)
        this.getTinymce().get(this.tinymceId).selection.collapse(false)
      }
    }
  },
  methods: {
    initTinymce() {
      this.$nextTick(async () => {
        // 配置选项
        const initOptions = {
          toolbar_mode: 'wrap',
          selector: `#${this.tinymceId}`,
          height: this.height,
          menubar: false,
          branding: false,
          paste_data_images: true,
          convert_urls: false,
          plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
          ],
          toolbar:
            `code fullscreen | undo redo | paste pastetext | formatselect fontsizeselect lineheight | bold italic underline forecolor backcolor  charmap |
           alignleft aligncenter alignright alignjustify | link unlink anchor |
           bullist numlist outdent indent | subscript superscript removeformat | image table media`,
          formats: {
            h1: { block: 'h1', classes: 'ipubw-h1' },
            h2: { block: 'h2', classes: 'ipubw-h2' },
            h3: { block: 'h3', classes: 'ipubw-p1' },
            p: { block: 'p', classes: 'ipubw-p2' }
          },
          block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h3',
          lineheight_formats: '0.2 0.5 0.7 0.8 1 1.2 1.5 1.7 2 2.2 2.5 3 3.5 4',
          content_style: `h1,h2,h3{
                          font-family: 'Times new roman';
                          margin-block-start: 0;
                          margin-block-end: 0;
                          margin-bottom: 12px;
                        }
                        ol, ul{ padding: 0;margin:0; }
                        ol li { margin-left: 20px; }
                        ul li { margin-left: 20px;position: relative; }
                        ul li::after {
                          content: '';
                          height: 4px;
                          width: 4px;
                          position: absolute;
                          top: 8px;
                          left: -16px;
                          border-radius: 50%;
                          background: #1E1D40;
                        }
                        p,div{
                          font-size: 16px,
                          line-height: 24px,
                          font-family: 'Open Sans', 'HelveticaNeue', 'Helvetica', 'Arial';
                        }
                        h1 {
                          font-size: 32px;
                          line-height: 40px;
                        }
                        h2 {
                          font-size: 24px;
                          line-height: 32px;
                        }
                        h3 {
                          font-size: 16px;
                          line-height: 24px;
                          font-family: 'Open Sans', 'HelveticaNeue', 'Helvetica', 'Arial';
                        }`,
          setup: editor => {
            editor.on('change input undo redo focus blur', () => {
              this.onChanged()
            })
            editor.on('blur', () => {
              this.handleBlur()
            })
            editor.on('focus', (e) => {
              this.handleFocus(e)
            })
          }
        }
        // 初始化
        await this.getTinymce().init(initOptions)
        this.hasInit = true
        this.setContent(this.value)
      })
    },
    setContent(content) {
      if (this.getTinymce().get(this.tinymceId)) {
        this.getTinymce().get(this.tinymceId).setContent(content)
      } else {
        console.log('tinymce init error')
      }
    },
    getContent() {
      if (this.getTinymce().get(this.tinymceId)) {
        return this.getTinymce().get(this.tinymceId).getContent()
      }else {
        console.log('tinymce init error')
      }
      return ''
    },
    onChanged() {
      const content = this.getContent() || ''
      this.$emit('input', content)
    },
    handleBlur() {
      this.isFocus = false
      const content = this.getContent() || ''
      this.$emit('blur', content)
    },
    handleFocus(e) {
      this.isFocus = true
      this.$emit('focus', e)
    },
    getTinymce() {
      const root = typeof window !== 'undefined' ? window : global
      return root && 'tinymce' in root ? root.tinymce : null
    },
    waitForTinyMCELoad() {
      if (window.tinymceLoaded) {
        this.initTinymce()
      } else {
        setTimeout(this.waitForTinyMCELoad, 100)
      }
    },
    loadTinymceScript() {
      const tinymceScriptId = 'tinymce-script'
      if (document.getElementById(tinymceScriptId)) {
        if (window.tinymceLoaded) {
          this.initTinymce()
        } else {
          this.waitForTinyMCELoad()
        }
      } else {
        const script = document.createElement('script')
        script.src = tinymceScript
        script.id = tinymceScriptId
        script.onload = () => {
          this.initTinymce()
          window.tinymceLoaded = true
        }
        document.body.appendChild(script)
      }
    }
  },
  destroyed() {
    const tinymce = this.getTinymce().get(this.tinymceId)
    if (tinymce) {
      tinymce.destroy()
    }
  }
}
</script>

<style lang='scss'>
.ipub-editor {
  transition: 0.3s all;
  border: 1px solid transparent;
  border-radius: 2px;
  overflow: hidden;

  &--active {
    border: 1px solid $link_color;
  }
}
</style>
